import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import StockItemModal from "../components/stockItemModal";
import StockClosingStockModal from "../components/stockClosingStockModal";
import Time from "../components/time";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";

const StockSummary = () => {
   useAuthRedirect();
  const [showModal, setShowModal] = useState(false);
  const [showStockModal, setStockShowModal] = useState(false);
  const [selectedItemCode, setSelectedItemCode] = useState(null); 
  const [data, setData] = useState([]);
  const branch = localStorage.getItem("branch");
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);

  const canView  = hasPermission("Stock Summary", "view");

    useEffect(() => {
    fetchData();
  }, [branch]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/itemMaster_list?branch=${branch}`);
      setData(response.data.itemList);
      setFilteredData(response.data.itemList);
    } catch (error) {
      console.error("Error fetching itemList:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
  
    if (term === "") {
      setFilteredData(data);
      return;
    }
  
    const filtered = data.filter((item) =>
      (String(item.itemmaster_code || "").toLowerCase().includes(term) ||
       String(item.itemmaster_name || "").toLowerCase().includes(term))
    );
  
    setFilteredData(filtered);
  };

  if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

   
  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle row click to open modal and set selected item code
  const handleRowClick = (itemCode) => {
    setSelectedItemCode(itemCode);
    setShowModal(true);
  };

  const handleStockRowClick = (itemCode) => {
    setSelectedItemCode(itemCode);
    setStockShowModal(true)

  };

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Stock Summary</h2>
          <Time />
        </section>

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by Item Name or Code"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Item Code</th>
                <th>Item Name</th>
                <th>UOM</th>
                <th>Closing Stock</th>
                <th>Price</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td onClick={() => handleRowClick(item.itemmaster_code)} style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}>
                      {item.itemmaster_code}
                    </td>
                    <td>{item.itemmaster_name}</td>
                    <td>{item.itemmaster_uom}</td>
                    <td onClick={() => handleStockRowClick(item.itemmaster_code)} style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}>{item.itemmaster_closingStock}</td>
                    <td>{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(item.itemmaster_price || 0)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
      
      {/* Modal Component */}
      <StockItemModal  showModal={showModal}  closeModal={() => setShowModal(false)}  branch={branch}  itemCode={selectedItemCode} />
      <StockClosingStockModal  showStockModal={showStockModal}  closeStockModal={() => setStockShowModal(false)}  branch={branch}  itemCode={selectedItemCode} />
    </div>
  );
};

export default StockSummary;
